import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema5/T5_SpinCard.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class SpinCard extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.38, -0.85, -2.6);
		this.rotation.set(-1.57, 0, -0.8);
		this.scale.set(3, 3, 3);
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Card = gltf.scene.getObjectByName("Spin_Card", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const CardFolder = gui.addFolder("Card");
		CardFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		CardFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		CardFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		CardFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		CardFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		CardFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		CardFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		CardFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		CardFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		CardFolder.add(this, "visible").name("visible");
	}
	onAnimateCard() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.Card
		this.Card.material.emissive.set("#404040");

		this.animation = gsap.to(this.Card.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
}